<template>
     <a-drawer
      title="发货"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="$emit('close')"
      :width="800"
      :bodyStyle="{padding:0}"
    >
        <div class="studentInfo">
            <span>学员姓名：张三</span>
            <span>联系电话：******</span>
            <span>微信：*******</span>
            <span>地址：********</span>
        </div>
        <div class="formBody">
            <a-form
                v-bind="formItemLayout"
            >
                <a-form-item label="选择课程包">
                    <a-select placeholder="请选择课程包">
                    <a-select-option :value="1" >
                       1
                    </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="发货类型">
                    <!-- <a-checkbox-group v-decorator="[ 'subauth', {initialValue: initname.subauth, rules: [{required: true, message: '请选择权限'}]}]" :options="plainOptions" @change="onChange" /> -->
                    <a-checkbox-group :options="plainOptions" />
                </a-form-item>
                <a-form-item label="快递公司">
                    <a-select  placeholder="请选择快递公司">
                        <a-select-option :value="1" >
                        1
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="快递单号">
                    <a-input  placeholder="请输入快递单号" />
                </a-form-item>
                <a-form-item label="是否微信、公众号推送">
                     <a-radio-group >
                        <a-radio :value="1">是</a-radio>
                        <a-radio :value="2">否</a-radio>
                    </a-radio-group>
                </a-form-item>
            </a-form>
            <div style="text-align:right;padding-top:30px">
                <a-button class="mr20px" style="width:80px" @click="$emit('close')">取消</a-button>
                <a-button type="primary"  style="width:80px">确定</a-button>
            </div>
        </div>
    </a-drawer>
</template>
<script>
export default {
    name: 'deliver',
    props: ['visible'],
    data(){
        this.plainOptions = 
            [{
                label:'教材',
                value:'1'
            },
            {
                label:'合同',
                value:'2'
            },
            {
                label:'资料',
                value:'3'
            },
            {
                label:'其他',
                value:'4'
            }
        ];
        return{
            formItemLayout: {
                labelCol: { span: 6 },
                wrapperCol: { span:10 },
            },
        }
    }
}
</script>
<style  scoped>
.studentInfo{
    display: flex;
    justify-content: space-between;
    color: #888888;
    border-bottom: 1px solid #eee;
    padding: 20px;
}
.formBody{
    padding: 20px;
}
</style>